const currentDomain = window.location.host

export const IS_WIKI_DOMAIN =
  currentDomain.includes('wlm-it-app.wmcloud.org') ||
  currentDomain.includes('app.wikilovesmonuments.it')

const IS_INMAGIK_DOMAIN = currentDomain.includes('wlm.inmagik.com')

export const API_URL = import.meta.env.PROD
  ? IS_WIKI_DOMAIN
    ? 'https://wlm-app.wmcloud.org/api/app'
    : IS_INMAGIK_DOMAIN
      ? 'https://wlm.inmagik.com/api/app'
      : 'https://wlm-staging-admin.wmcloud.org/api/app'
  : 'http://localhost:8000/api/app'

export const URL_WIKI = IS_WIKI_DOMAIN
  ? 'https://commons.wikimedia.org/wiki'
  : IS_INMAGIK_DOMAIN
    ? 'https://wikitest.inmagik.com/index.php'
    : 'https://commons-wlm.wmcloud.org'

export const FILTERS_OPEN_STORAGE_KEY = 'blockFilters:isOpen'
